// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_71-6";
export var headerCell = "_71-2";
export var rowWrapper = "_71-4";
export var stickyAggregationCell = "_71-a";
export var stickyAggregationRow = "_71-7";
export var stickyColumnCell = "_71-9";
export var stickyColumnHeaderCell = "_71-8";
export var table = "_71-1";
export var virtualRowWrapper = "_71-5";
export var virtualTableContainer = "_71-0";
export var white = "_71-3";